/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react"
import PropTypes from "prop-types"
import { uniqueId } from "lodash"

import { buildFormControllClass } from "../../helpers/formUtils"

import * as Icon from "react-feather"

const Input = ({
  id,
  className,
  placeholder,
  label,
  hide_label,
  type,
  required,
  hidden,
  disable,
  value,
  onChange,
  onFocusOut,
  isValid,
}) => {
  const htmlId = uniqueId(id)
  return (
    <div
      className={`form-control${buildFormControllClass(
        className,
        hidden,
        required,
        isValid,
        disable
      )}`}
    >
      {label && !hide_label && (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label
          htmlFor={htmlId}
          className="form-control__label"
          dangerouslySetInnerHTML={{ __html: label }}
        />
      )}
      <div className="form-control__content">
        <div className="form-control__faux">
          {type === "email" && (
            <Icon.Mail className="form-control__input-icon form-control__icon--new icon icon--sm" />
          )}
          {type === "tel" && (
            <Icon.Phone className="form-control__input-icon form-control__icon--new icon icon--sm" />
          )}
          {type === "text" && (
            <Icon.User className="form-control__input-icon form-control__icon--new icon icon--sm" />
          )}
          <input
            id={htmlId}
            type={type}
            className="form-control__input form-control__input--input"
            placeholder={placeholder}
            required={required}
            disabled={disable}
            value={value}
            onChange={(e) => {
              if (id !== "") {
                const { value } = e.target
                onChange(id, value)
              } else onChange(e)
            }}
            onBlur={(e) => {
              if (id !== "") {
                onFocusOut(id, e.target)
              } else onFocusOut(e)
            }}
          />
        </div>
      </div>
    </div>
  )
}

Input.defaultProps = {
  id: "",
  className: "",
  placeholder: "",
  label: "",
  type: "text",
  hidden: false,
  required: false,
  disable: false,
  value: "",
  isValid: true,
  onChange: () => {},
  onFocusOut: () => {},
}

Input.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  hide_label: PropTypes.bool,
  type: PropTypes.string,
  required: PropTypes.bool,
  disable: PropTypes.bool,
  hidden: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocusOut: PropTypes.func,
  isValid: PropTypes.bool,
}

export default Input
